export const REIMBURSEMENT_STATUS = {
  PENDING_CONFIRM: "待确认",
  PENDING_SUPERIOR_AUDIT: "待上级审核",
  PENDING_PAYMENT: "待付款",
  PENDING_FINANCE_AUDIT: "待财务审核",
  PENDING_PAYMENT_AUDIT: "待支付审核",
  PAYMENT_COMPLETED: "付款完成",
  VOID: "作废",
};

export const REIMBURSEMENT_STATUS_LIST = [
  REIMBURSEMENT_STATUS.PENDING_CONFIRM,
  REIMBURSEMENT_STATUS.PENDING_SUPERIOR_AUDIT,
  REIMBURSEMENT_STATUS.PENDING_PAYMENT,
  REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT,
  REIMBURSEMENT_STATUS.PENDING_PAYMENT_AUDIT,
  REIMBURSEMENT_STATUS.PAYMENT_COMPLETED,
  REIMBURSEMENT_STATUS.VOID,
];

export const REIMBURSEMENT_STATUS_TABS = [
  { name: REIMBURSEMENT_STATUS.PENDING_CONFIRM, label: "待确认", showBadge: true },
  { name: REIMBURSEMENT_STATUS.PENDING_SUPERIOR_AUDIT, label: "待上级审核", showBadge: true },
  { name: REIMBURSEMENT_STATUS.PENDING_PAYMENT, label: "待付款", showBadge: true },
  { name: REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT, label: "待财务审核", showBadge: true },
  { name: REIMBURSEMENT_STATUS.PENDING_PAYMENT_AUDIT, label: "待支付审核", showBadge: true },
  { name: REIMBURSEMENT_STATUS.PAYMENT_COMPLETED, label: "付款完成", showBadge: false },
  { name: REIMBURSEMENT_STATUS.VOID, label: "作废", showBadge: true },
  { name: "全部", label: "全部", showBadge: false },
];

export const REIMBURSEMENT_VOIDABLE_STATUSES = [
  REIMBURSEMENT_STATUS.PENDING_CONFIRM,
  REIMBURSEMENT_STATUS.PENDING_SUPERIOR_AUDIT,
  REIMBURSEMENT_STATUS.PENDING_PAYMENT,
  REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT,
  REIMBURSEMENT_STATUS.PENDING_PAYMENT_AUDIT,
];

export const REIMBURSEMENT_REJECTABLE_STATUSES = [
  REIMBURSEMENT_STATUS.PENDING_SUPERIOR_AUDIT,
  REIMBURSEMENT_STATUS.PENDING_PAYMENT,
  REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT,
  REIMBURSEMENT_STATUS.PENDING_PAYMENT_AUDIT,
];

/** 可编辑：待确认、待付款、待财务审核 */
export const REIMBURSEMENT_EDITABLE_STATUSES = [
  REIMBURSEMENT_STATUS.PENDING_CONFIRM,
  REIMBURSEMENT_STATUS.PENDING_PAYMENT,
  REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT,
];

/** 打回：按正向流转的逆序，逐级回退 */
export const REIMBURSEMENT_ACTION_REJECT = {
  [REIMBURSEMENT_STATUS.PENDING_SUPERIOR_AUDIT]: REIMBURSEMENT_STATUS.PENDING_CONFIRM,
  [REIMBURSEMENT_STATUS.PENDING_PAYMENT]: REIMBURSEMENT_STATUS.PENDING_SUPERIOR_AUDIT,
  [REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT]: REIMBURSEMENT_STATUS.PENDING_PAYMENT,
  [REIMBURSEMENT_STATUS.PENDING_PAYMENT_AUDIT]: REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT,
};

/** 当前状态对应的主操作按钮文案 */
export const REIMBURSEMENT_PRIMARY_ACTION = {
  [REIMBURSEMENT_STATUS.PENDING_CONFIRM]: { action: "submit", label: "提交审核" },
  [REIMBURSEMENT_STATUS.PENDING_SUPERIOR_AUDIT]: { action: "approve", label: "审核报销" },
  [REIMBURSEMENT_STATUS.PENDING_PAYMENT]: { action: "approve", label: "确认支付" },
  [REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT]: { action: "approve", label: "审核通过" },
  [REIMBURSEMENT_STATUS.PENDING_PAYMENT_AUDIT]: { action: "approve", label: "审核通过" },
};
